<template>
  <div
    ref="item"
    class="list-item"
    :class="{ 'list-item-alternate': alternate, 'list-item-predefined': garage !== null, 'is-invisible': !visible, 'is-active': selected, 'list-item-standalone': standalone, 'is-app': $isApp }"
    v-on="$listeners"
  >
    <slot v-if="!garage" />
    <template v-else>
      <div class="garage-section">
        <div class="garage-city">
          {{ garage.city }}
        </div>
        <a class="garage-name" :href="getGarageUri">{{ garage.name }}</a>
      </div>
      <div class="garage-section">
        <div class="garage-address">
          {{ getComposedStreet(garage.street_type) }} {{ garage.street }}, {{ garage.postal_code }}
        </div>
        <div class="garage-phones">
          {{ $translate('phone-shortcut', 'tel.') }} {{ garage.phones.join(' & ') }}
        </div>
      </div>
      <div ref="labelsWrap" class="garage-section d-flex flex-wrap">
        <Label
          ref="labels"
          v-for="(label, i) in labels"
          :key="i"
          :title="label"
        />
      </div>
    </template>
    <template v-if="standalone && !$isApp && isAvaliableMakeAnAppointment && isMakeAnAppointment">
      <div class="garage-cta">
        <a href="#" @click="$emit('click:cta')">UMÓW WIZYTĘ W WARSZTACIE</a>
      </div>
    </template>
  </div>
</template>

<script>
import Label from './label'
import { setTimeout } from 'timers';
import { getComposedStreet } from '../helpers/street-type-composer';

export default {
  name: 'ListItem',
  components: {
    Label
  },
  props: {
    alternate: {
      type: Boolean,
      required: false,
      default: false
    },
    garage: {
      type: Object,
      required: false,
      default: null
    },
    labelsRows: {
      type: Number,
      required: false,
      default: 2
    },
    selected: {
      type: Boolean,
      required: false,
      default: false
    },
    standalone: {
      type: Boolean,
      required: false,
      default: false
    },
    isMakeAnAppointment: {
      type: Boolean,
      required: false,
      default: true,
    }
  },
  data () {
    return {
      height: 0,
      mutatedLabels: [],
      visible: true,
      getComposedStreet: getComposedStreet.bind(this)
    }
  },
  created () {
    if (!this.garage) {
      return
    }

    this.mutatedLabels = this.garage.services.map((service) => {
      return service.name
    })
  },
  mounted () {
    if (this.mutatedLabels.length) {
      setTimeout(() => {
        const maxHeight = (this.$refs.labels[0].$el.getBoundingClientRect().height + 4) * this.labelsRows
        const currentHeight = this.$refs.labelsWrap.getBoundingClientRect().height

        const maxWidth = this.$refs.labelsWrap.getBoundingClientRect().width * this.labelsRows

        if (currentHeight > maxHeight) {
          let width = 0
          let i = 0
          while (width < maxWidth && i < this.$refs.labels.length) {
            width += this.$refs.labels[i].$el.getBoundingClientRect().width + 4

            i++
          }

          this.mutatedLabels = this.mutatedLabels.slice(0, i - 2)
          this.mutatedLabels.push(`+ ${this.garage.services.length - (i - 2)}`)
        }

        this.$nextTick(() => {
          this.height = this.$refs.item.getBoundingClientRect().height
        })
      }, 1)
    } else {
      this.$nextTick(() => {
        this.height = this.$refs.item.getBoundingClientRect().height
      })
    }
  },
  computed: {
    labels () {
      return this.mutatedLabels
    },
    getGarageUri () {
      return `${window.garagePath}/${this.garage.slug}`
    },
    isAvaliableMakeAnAppointment () {
      return this.garage.booking_enabled;
    },
  },
  methods: {
    setVisibility (val) {
      this.visible = val
    }
  }
}
</script>
